/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { Avatar, Input, Typography, Skeleton } from "@mui/material";
import { Box } from "@mui/system";
import { styled } from "@mui/material/styles";
import { fonts } from "../../themes/themes";
import { useTranslation } from "react-i18next";
interface IProfilePicProps {
  profilePic?: string;
  setNewProfilePic: (data: any) => void;
}

const UpdateProfilePic = ({
  profilePic,
  setNewProfilePic,
}: IProfilePicProps) => {
  const { t } = useTranslation();
  const trans = t;
  const CustomInput = styled(Input)({
    display: "none",
  });
  const [isUpdate, setIsUpdate] = useState(false);

  const [loder, setLoder] = useState(false);

  const [, setNewProfilePicc] = useState("");
  const [, setNewProfilePicPath] = useState("");

  const handleUpdateProfilePic = (e: any) => {
    const image_as_base64: any = URL.createObjectURL(e.target.files[0]);
    const image_as_files = e.target.files[0];
    setNewProfilePicc(image_as_files);
    setNewProfilePicPath(image_as_base64);
    setNewProfilePic(image_as_files);
  };
  useEffect(() => {
    if (profilePic == "show_loader") {
      setLoder(true);
    } else {
      setLoder(false);
    }
  }, [profilePic]);
  
  return (
    <Box
      onMouseEnter={() => setIsUpdate(true)}
      onMouseLeave={() => setIsUpdate(false)}
    >
      {loder ? (
        <Skeleton
          variant="circular"
          style={{
            background: "transparent 0% 0% no-repeat padding-box",
            boxShadow: "0px 3px 6px #00000029",
            border: "3px solid #ffffff",
            opacity: isUpdate ? "0.5" : "1",
            height: "6em",
            width: "6em",
            borderRadius: "50%",
          }}
        />
      ) : (
        <Avatar
          src={profilePic}
          style={{
            background: "transparent 0% 0% no-repeat padding-box",
            boxShadow: "0px 3px 6px #00000029",
            border: "3px solid #ffffff",
            opacity: isUpdate ? "0.5" : "1",
            height: "6em",
            width: "6em",
            borderRadius: "50%",
          }}
        />
      )}

      {isUpdate && (
        <label htmlFor="icon-button-file">
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              zIndex: "1",
              opacity: "1",
              marginTop: "-5.5em",
              marginLeft: "2em",
              position: "absolute",
            }}
          >
            <CustomInput
              id="icon-button-file"
              type="file"
              onChange={(e: any) => handleUpdateProfilePic(e)}
            />
            <i
              className="las la-camera"
              style={{
                color: "white",
                fontSize: "25px",
                cursor: "pointer",
              }}
            ></i>{" "}
            <Typography
              style={{
                fontFamily: fonts.fontFamily,
                fontSize: fonts.title,
                fontWeight: "bold",
                color: "white",
                cursor: "pointer",
              }}
            >
              {trans("Update Photo")}
            </Typography>
          </Box>
        </label>
      )}
    </Box>
  );
};
export default UpdateProfilePic;
